var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"text-left",attrs:{"cols":"12"}},[_c('div',{style:('color:' + _vm.color),domProps:{"innerHTML":_vm._s(_vm.texto)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }